// src/mocks/handlers/user/index.ts

import { userCustomersHandler } from './userCustomersHandler';
import { userProfileHandler } from './userProfileHandler';

export const userHandlers = [userCustomersHandler, userProfileHandler];
